import { CATEGORY, TRACK_TYPE } from '@lib/analytics/events';
import { stores } from '@stores/.';
import { prettyPrintUserRole } from './utils';

type Event = Record<string, unknown> & {
  name?: never;
  userId?: never;
  workspace_id?: never;
  num_users?: never;
  user_permissions?: never;
  company?: never;
  account_type?: never;
  first_login?: never;
};

const enhanceProps = (props: Event) => {
  const { userStore, workspaceStore, organizationStore } = stores;
  const { id, email, selectedWorkspaceId, loggedIn, name, firstTimeLogin } = userStore;
  if (loggedIn) {
    let result: Record<string, unknown> = {
      userId: id,
      email,
      name,
      workspace_id: selectedWorkspaceId,
      first_login: firstTimeLogin,
      ...props,
    };
    if (workspaceStore.id) {
      result = {
        ...result,
        num_users: workspaceStore.members.length,
        user_permissions: prettyPrintUserRole(userStore),
        company: organizationStore.name,
        account_type: organizationStore.prettyPrintTier(),
      };
    }
    return result;
  }
  return props;
};

class Analytics {
  public track = (
    message: string,
    action: TRACK_TYPE,
    category?: CATEGORY | undefined,
    p: Event = {},
  ): void => {
    const props = enhanceProps(p);
    window?.rudderanalytics?.track(message, { action, category, ...props });
  };

  public track2 = (message: string, action: TRACK_TYPE, event: Event) => {
    this.track(message, action, undefined, event);
  };

  public page = (
    category: CATEGORY,
    name: string,
    properties: Record<string, unknown> = {},
    cb: () => void = () => null,
  ) => {
    const options = enhanceProps({});
    if (cb) {
      window?.rudderanalytics?.page(category, name, properties, options, cb);
      return;
    }
    window?.rudderanalytics?.page(category, name, properties, options);
  };

  public reset = () => {
    window.rudderanalytics.reset(true);
  };
}

export const analytics = new Analytics();
